<template>
    <div id="contact">
        <!-- <Titulos :titu="'CONTACT'"></Titulos> -->
        <h2>GET IN TOUCH</h2>
        <a href="mailto:hello@nicolasrivera.com.ar" class="mail">hello<span>@</span>nicolasrivera.com.ar</a>
        <footer>
            <!-- <ul>
                <li>About</li>
                <li>Works</li>
                <li>Illustrations</li>
                <li>Contact</li>
            </ul> -->
            <div id="redes">
                <a href="https://instagram.com/nicoamigo" target="_blank" class="red tw"></a>
                <a href="https://www.linkedin.com/in/riveranicolas/" target="_blank" class="red lk"></a>
            </div>
        </footer>
        <p class="rig">© {{ anio }} nicolasrivera.com.ar</p>
    </div>
</template>

<script>
// import Titulos from './Titulos.vue'

export default {
    // components: {
    //     Titulos
    // },
    data(){
        return {
            anio: 0
        }
    },
    mounted: function () {
        this.getAnio()
    },
    methods: {
        getAnio() {
            this.anio = new Date().getFullYear()
        }
    }
}
</script>

<style lang="scss" scoped>
#contact{
    width: 100%;
    // height: 350px;
    padding: 20px 0 30px;
    background: linear-gradient(180deg,rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);
    margin: 50px auto 0;

    h2{
        font-size: 1.8rem;
        color: #fff;
        letter-spacing: 50px;
        text-align: center;
        margin: 10px auto 10px;
        font-weight: 200;
        transform: translateX(2%);
    }
    .mail{
        font-size: 1.3rem;
        color: aqua;
        letter-spacing: 2px;
        text-decoration: none;
        font-weight: 300;
        line-height: 1.75rem;
        text-align: center;
        display: block;
        width: 100%;
        background-color: transparent;
        transition: all .3s ease;
        padding: 5px 0;
        cursor: pointer;
        
        span{
            // transition: all .3s ease;
            color: var(--white);
            font-weight: 600;
        }
        &:hover{
            // background-color: #96cdff;
            background-color: aqua;
            color: var(--black);
            span{
                color: var(--white);
            }
        }
    }

    footer{
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: center;
        width: 400px;
        margin: 30px auto;

        ul{
            flex-grow: 2;
            list-style-type: circle;

            li{
                color: #fff;
                margin: 10px auto;
            }
        }
        #redes{
            display: flex;
            justify-content: center;
            gap: 20px;
            flex-grow: 1;
            align-items: center;

            .red{
                width: 40px;
                height: 40px;
                background-size: 130px;
                transition: all .3s ease;
                align-self: flex-end;
                position: relative;
                opacity: 1;
                background-color: transparent;
                cursor: pointer;

                &:before{
                    content: '';
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    position: absolute;
                    top: 15px;
                    left: 15px;
                }
                &:hover{
                    animation: gran .3s ease-in 1;
                }

                &.tw{
                    background-image: url('../assets/img/redesW.png');
                    background-position: -89px 0px;
                }
                &.lk{
                    background-image: url('../assets/img/redesW.png');
                    background-position: -45px 0px;
                }
            }
        }
    }
    .rig{
        color: #fff;
        margin: 20px auto;
        font-size: 0.7rem;
        text-align: center;
        letter-spacing: 3px;

        span{
            display: inline;
        }
        br{
            display: none;
        }
    }
    @keyframes gran {
        0% {
            background-position-y: center;
            opacity: 1;
        }
        15% {
            background-position-y: -30px;
            opacity: 0;
        }
        50% {
            background-position-y: 30px;
            opacity: 0;
        }
        85% {
            background-position-y: 30px;
            opacity: 1;
        }
        100% {
            background-position-y: center;
            opacity: 1;
        }
    }
}
@media screen and (max-width: 800px){
    #contact{
        h2{
            font-size: 1.7rem;
            letter-spacing: 30px;
        }
    }
}
@media screen and (max-width: 600px){
    #contact{
        padding: 10px 0 30px;
        margin: 0px auto;

        h2{
            font-size: 1.5rem;
            letter-spacing: 15px;
        }
        .mail{
            font-size: 1.1rem;
        }
        footer{
            width: 80%;

            ul{
                padding-inline-start: 10px;
            }
        }
        .rig{
            font-size: 0.7rem;

            span{
                display: none;
            }
            br{
                display: inline;
            }
        }
    }
}
</style>